import { EventType, SourcePages, ImpressionType } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';
import { VehicleEventInfo } from '../types';

interface SearchResultEventInfo extends VehicleEventInfo {
  sourcePage: SourcePages;
  page: string;
  searchResultIndex: string;
  vin: string;
}

function event({
  trackingParams,
  sourcePage,
  page,
  searchResultIndex,
  vin,
}: SearchResultEventInfo): EventData {
  return {
    event_type: EventType.listingImpression,
    source_page: sourcePage,
    impression_type: ImpressionType.srpResult,
    event_context: {
      tracking_params: trackingParams,
      page,
      search_result_index: searchResultIndex,
      vin,
    },
  };
}

export default event;
